import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAppDispatch, useAppSelector } from '../store/hooks';
import { signOut } from '../store/AdminSlices/adminUserSlice';
import { Skeleton } from '../components/Skeleton';

const AdminDetectedPage: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useAppDispatch();
  const { currentUser } = useAppSelector((state) => state.adminUser);
  const [imageLoaded, setImageLoaded] = useState(false);

  const handleLoginToAdmin = () => {
    navigate('/');
  };

  const handleBackToLogin = async () => {
    try {
      await dispatch(signOut()).unwrap();
    } catch (err) {
      // Ignore sign-out errors
    }
    window.location.href = process.env.REACT_APP_AUTH_REDIRECT || 'https://guiding-hedgehog-41.accounts.dev/sign-in';
  };

  return (
    <div className="min-h-screen bg-white flex flex-col items-center justify-center px-6 py-12">
      {/* Header */}
      <div className="text-center mb-16">
        <h1 className="text-2xl font-semibold text-gray-900 mb-1">Onefinnet Coaching</h1>
        <p className="text-sm text-gray-500">Expert coaching, personalized growth</p>
      </div>

      {/* Main Content */}
      <div className="w-full max-w-4xl text-center">
        {/* Dashboard Preview with bottom half blurred */}
        <div className="mx-auto max-w-3xl relative overflow-hidden rounded-lg">
          {!imageLoaded && (
            <Skeleton 
              variant="rectangular" 
              width="100%" 
              height="500px"
              className="animate-pulse"
            />
          )}
          <img 
            src="https://ecn.blob.core.windows.net/ecn/images/FINAL Dashboard.png" 
            alt="Dashboard preview"
            className={`w-full h-auto transition-opacity duration-300 ${imageLoaded ? 'opacity-100' : 'opacity-0'}`}
            onLoad={() => setImageLoaded(true)}
          />
          {/* Blurred bottom half overlay */}
          {/* <div 
            className="absolute bottom-0 left-0 right-0 h-1/2 bg-cover bg-center"
            style={{
              backgroundImage: 'url(https://ecn.blob.core.windows.net/ecn/images/FINAL Dashboard.png)',
              backgroundPosition: 'center bottom',
              filter: 'blur(8px)',
            }}
          ></div> */}
          {/* White gradient overlay */}
          {imageLoaded && (
            <div className="absolute bottom-0 left-0 right-0 h-1/2 bg-gradient-to-t from-white via-white/60 to-transparent"></div>
          )}
        </div>

        {/* Message and Buttons - Overlapping */}
        {imageLoaded ? (
          <div className="relative -mt-32 space-y-6 px-4 animate-fadeIn">
            <h2 className="text-2xl font-semibold text-gray-900 leading-relaxed">
              We found an admin account linked to {currentUser?.email || 'your account'}
            </h2>

            {/* Buttons */}
            <div className="flex flex-col items-center gap-4">
              <button
                onClick={handleLoginToAdmin}
                className="w-full max-w-sm py-3 bg-gray-900 text-white rounded-lg text-sm font-medium transition-all hover:bg-gray-800 active:scale-[0.98]"
              >
                Go to Admin Dashboard
              </button>
              <button
                onClick={handleBackToLogin}
                className="text-sm text-gray-900 underline hover:text-gray-700 transition-colors"
              >
                Back to Login
              </button>
            </div>
          </div>
        ) : (
          <div className="relative mt-8 space-y-6 px-4">
            <Skeleton variant="text" width="70%" height="32px" className="mx-auto" />
            <div className="flex flex-col items-center gap-4 mt-6">
              <Skeleton variant="rectangular" width="384px" height="48px" className="rounded-lg" />
              <Skeleton variant="text" width="100px" height="20px" />
            </div>
          </div>
        )}
      </div>
    </div>
  );
};

export default AdminDetectedPage;
